module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/097-san-marino-fdf144c7f403ff56d8c889c8cc7b7ef5.svg";